import React from 'react';
import { Card, Table } from 'react-bootstrap';

import classNames from 'classnames';
import dateFormat from 'dateformat';

import newsStyles from '@components/Dashboard/News/News.module.scss';
import styles from '@containers/Dashboard/Dashboard.module.scss';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page500 } from '@containers/ErrorPages';
import { dashboardApi } from '@reducers/dashboard/dashboard';

export const News = () => {
  const { data, isLoading, isError } = dashboardApi.useGetNewsQuery();
  const { messageTypeAlert } = newsStyles;
  return (
    <Card>
      <Card.Header className="text-center bg-didxl text-white">
        News
      </Card.Header>
      <Card.Body className={`${styles.scroll} ${styles.firstRow}`}>
        {isLoading ? <DefaultSpinnerCenter /> : null}
        {isError ? <Page500 /> : null}
        {!isLoading && !isError ? (
          <Table borderless>
            <tbody className="normalFontSize">
              {data.map(({ id, created, description, type }) => {
                const date = new Date(created);
                const formattedDate = dateFormat(date, 'd mmm yyyy');
                return (
                  <tr key={id}>
                    <td
                      className={classNames(
                        'text-nowrap',
                        styles.dashboardDate
                      )}
                    >
                      {formattedDate}
                    </td>
                    <td>
                      <span
                        className={classNames({
                          [messageTypeAlert]: type === 'alert',
                        })}
                      >
                        {description}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : null}
      </Card.Body>
    </Card>
  );
};
